<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import download from "@core/assets/icons/download.svg?raw";
	import type { Attachment } from "@core/schema/Attachment.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { getUploadedFileExtension } from "@core/utils/getUploadedFileExtension.js";
	import { getUploadedFilePath } from "@core/utils/getUploadedFilePath.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import Formatted from "./common/Formatted.svelte";
	import Heading from "./common/Heading.svelte";
	import Icon from "./common/Icon.svelte";
	import Link from "./common/Link.svelte";

	const { attachments }: { attachments: Attachment[] } = $props();

	const { FILE_BUCKET_URL_MAP } = getGlobalSettings();
</script>

{#if attachments.length > 0}
	<div class="container-8">
		<Heading level={2} text="Přílohy" class="my-4 text-cmcsecondary uppercase font-bold" />
		<div class="flex-col flex gap-4">
			{#each attachments as attachment (attachment.path)}
				{@const fileName = `${attachment.title}.${getUploadedFileExtension(attachment)}`}
				<div class="flex flex-col gap-y-2 p-4 sm:items-center sm:flex-row bg-white rounded-xl">
					<div class="truncate text-xs/none font-medium md:text-sm">
						<Formatted text={attachment.title} />
					</div>
					<Link
						variant={ButtonVariant.Primary}
						href={getUploadedFilePath(attachment, FILE_BUCKET_URL_MAP)}
						download={fileName}
						class="mx-auto mt-2 !flex !w-fit sm:mr-0"
					>
						Stáhnout

						{#snippet icon()}
							<Icon icon={download} class="size-4 md:size-6" />
						{/snippet}
					</Link>
				</div>
			{/each}
		</div>
	</div>
{/if}
